export const getServiceUrl = (album, service) => {
    switch (service) {
      case 'spotify': return `spotify:album:${album.spotifyId}`;
      case 'youtubeMusic': return `https://music.youtube.com/playlist?list=${album.youtubeMusicId}`;
      case 'appleMusic': return `https://music.apple.com/album/${album.appleMusicId}`;
      case 'amazonMusic': return `https://music.amazon.com/albums/${album.amazonMusicId}`;
      case 'tidal': return `https://tidal.com/browse/album/${album.tidalId}`;
      case 'deezer': return `https://www.deezer.com/album/${album.deezerId}`;
      case 'qobuz': return `https://play.qobuz.com/album/${album.qobuzId}`;
      default: return null;
    }
  };